module.exports = __webpack_public_path__ + "img/hipushit_no.2c61a7d5.png";